import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Support from "./pages/Support";
import Involved from "./pages/Involved";
import Volunteer from "./pages/Volunteer";
import About from "./pages/About";
import Contact from "./pages/Contact";
import "./fonts/Universal-Sans-Display-330.ttf";
import Cookies from "./pages/Cookies";
import VolunteerInformationFAQ from "./pages/VolunteerInformationFAQ";
import RoleDescription from "./pages/RoleDescription";
import TrainingScheduleEastLondon from "./pages/TrainingScheduleEastLondon";
import TrainingScheduleCroydon from "./pages/TrainingScheduleCroydon";
import ApplicationTemplate from "./pages/ApplicationTemplate";
import { initializeGA } from "./utils/googleAnalytics";

// Initialize Google Analytics (only works if REACT_APP_GA_TRACKING_ID is set)
initializeGA();

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<Home />} />
          <Route path="get-support" element={<Support />} />
          <Route path="get-involved" element={<Involved />} />
          <Route path="volunteer-with-us" element={<Volunteer />} />
          <Route path="about-us" element={<About />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="cookies" element={<Cookies />} />
          <Route path="uploads/volunteer-information-faq" element={<VolunteerInformationFAQ />} />
          <Route path="uploads/role-description" element={<RoleDescription />} />
          <Route path="uploads/training-schedule-east-london" element={<TrainingScheduleEastLondon />} />
          <Route path="uploads/training-schedule-croydon" element={<TrainingScheduleCroydon />} />
          <Route path="uploads/application-template" element={<ApplicationTemplate />} />
          {/* <Route path="*" element={<NoPage />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
